import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotArticles from './components/HotArticles';
import ArticleList from './components/ArticleList';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="首页"
        description="黑料社区是专注于独家爆料、真实内幕揭秘的聚合平台。海量用户实名分享亲历黑料，覆盖娱乐、商业、职场等多领域。加入黑料社区，第一时间获取最新最真实的内幕信息。"
        keywords="黑料社区,黑料爆料平台,娱乐圈黑料,明星内幕爆料,商业黑料揭秘,职场黑料分享,真实内幕社区,独家黑料资讯"
        canonicalUrl="https://heiliaoshequ.com/"
        ogImage="https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20style%20banner%20for%20an%20investigative%20journalism%20platform%2C%20dark%20atmosphere%20with%20warm%20crimson%20and%20amber%20accents%2C%20newspaper%20collage%20textures%2C%20Chinese%20characters%20heiliaoshequ%20in%20bold%20typography%2C%20mysterious%20and%20trustworthy%20mood%2C%20no%20blue%20or%20purple%20tones&width=1200&height=630&seq=home-og-2026&orientation=landscape"
      />
      <SchemaOrg type="Organization" data={{}} />
      <SchemaOrg type="WebSite" data={{}} />
      <SchemaOrg type="WebPage" data={{
        name: '黑料社区 - 首页',
        url: 'https://heiliaoshequ.com/',
        description: '黑料社区是专注于独家爆料、真实内幕揭秘的聚合平台。',
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar transparent />
        <main>
          <HeroSection />
          <CategoryNav />
          <HotArticles />
          <ArticleList />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}